<template>
  <a :href="href" :class="['t-button', baseClass]">
    <span class="t-label">
      <span :class="['t-icon-spot', iconClass]"></span>
      <span class="t-label-text"><slot></slot></span>
    </span>
  </a>
</template>

<script>
import BaseMixin from './BaseMixin.vue'

export default {
  name: 'ButtonLink',

  mixins: [BaseMixin],

  props: {
    href: {
      type: String,
      default: '#',
    },
  },
}
</script>
